import Helpers from '../../../../common/helpers/Helpers';
import Constants from '../../../../common/constants/Constants';

export const getEventStatisticsData = (
  serialNumber,
  table,
  dateFrom,
  dateTo,
  selectAllPerDay,
  selectedAssay
) => {
  let query = {
    SelectedInstrument: serialNumber,
    ReportName: table,
    StartDate: dateFrom,
    EndDate: dateTo,
    SelectAllPerDay: selectAllPerDay,
    SelectedAssay: selectedAssay
  };

  return Helpers.get(`${Constants.OLDREPORTS_URL}`, {}, query);
};
